import {
    SET_ZONE_OPTIONS,
    FETCH_ALL_ZONES,
    SET_ALL_ZONES,
    GET_ZONE_PARKING_ASSISTANT_SETTINGS,
    SET_ZONE_PARKING_ASSISTANT_SETTINGS,
    UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
    type ZoneOption,
} from 'src/redux/zone/zone.types'
import { type ParkingAssistantSettings, type Zone } from 'src/api/fm/zones/zones.model'

export type GetZoneAction<T extends ZoneAction['type']> = Extract<ZoneAction, { type: T }>

export type ZoneAction =
    | ReturnType<typeof setZoneOptions>
    | ReturnType<typeof fetchAllZones>
    | ReturnType<typeof setAllZones>
    | ReturnType<typeof getZoneParkingAssistantSettings>
    | ReturnType<typeof setZoneParkingAssistantSettings>
    | ReturnType<typeof updateZoneParkingAssistantSettings>

export const setZoneOptions = (zones: ZoneOption[]) => {
    return {
        type: SET_ZONE_OPTIONS,
        payload: zones,
    }
}

export const fetchAllZones = () => ({
    type: FETCH_ALL_ZONES,
})

export const setAllZones = (zones: Zone[]) => ({
    type: SET_ALL_ZONES,
    payload: zones,
})

export const getZoneParkingAssistantSettings = (zoneId: string) => ({
    type: GET_ZONE_PARKING_ASSISTANT_SETTINGS,
    payload: zoneId,
})

export const setZoneParkingAssistantSettings = (settings: ParkingAssistantSettings) => {
    return {
        type: SET_ZONE_PARKING_ASSISTANT_SETTINGS,
        payload: settings,
    }
}

export const updateZoneParkingAssistantSettings = (settings: ParkingAssistantSettings) => {
    return {
        type: UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
        payload: settings,
    }
}
